import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `DELETE …/workflow-runs/{run}/handling` carries no body: the target is entirely in the URL. */
class UnmarkWorkflowRunHandled {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly runId: number,
	) {
		Object.freeze(this);
	}
}

export default UnmarkWorkflowRunHandled;
